import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';
import { EMPTY, catchError, map, of, tap } from 'rxjs';

export const loginGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	const { state } = router.getCurrentNavigation()?.extras ?? {};

	if (authService.tokenNotExpired) {
		if (state && state.logout) {
			return authService.logout().pipe(
				tap(() => authService.clearAuthData()),
				catchError(() => {
					authService.clearAuthData();
					return EMPTY;
				}),
				map(() => true)
			);
		}
		if (!authService.user) {
			return authService.refreshToken().pipe(
				tap(() => authService.navigateAfterLogin()),
				map(() => false),
				catchError(() => {
					authService.clearAuthData();
					return of(true);
				})
			);
		}
		authService.navigateAfterLogin();
		return false;
	}
	return true;
};
